import React from 'react';
import { useCurrentWeighing, useWeighingLoading, useWeighingError, useWeighing } from '@/contexts/WeighingContext';

interface CurrentWeighingInfoProps {
  className?: string;
}

const CurrentWeighingInfo: React.FC<CurrentWeighingInfoProps> = ({ className = '' }) => {
  const currentWeighing = useCurrentWeighing();
  const isLoading = useWeighingLoading();
  const error = useWeighingError();
  const { state } = useWeighing();

  if (isLoading) {
    return (
      <div className={`bg-blue-50 border border-blue-200 rounded-lg p-4 ${className}`}>
        <div className="flex items-center">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600 mr-2"></div>
          <span className="text-blue-600 text-sm">Chargement des données de pesée...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`bg-red-50 border border-red-200 rounded-lg p-4 ${className}`}>
        <div className="flex items-center">
          <div className="text-red-600 mr-2">⚠️</div>
          <span className="text-red-600 text-sm">Erreur: {error}</span>
        </div>
      </div>
    );
  }

  if (!currentWeighing) {
    return (
      <div className={`bg-gray-50 border border-gray-200 rounded-lg p-4 ${className}`}>
        <div className="flex items-center">
          <div className="text-gray-500 mr-2">ℹ️</div>
          <span className="text-gray-600 text-sm">Aucune pesée en cours</span>
        </div>
      </div>
    );
  }

  return (
    <div className={`bg-green-50 border border-green-200 rounded-lg p-4 ${className}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div className="text-green-600 mr-2">✅</div>
          <div>
            <span className="text-green-800 font-medium text-sm">
              Pesée active: {currentWeighing.reference}
            </span>
            <div className="text-green-600 text-xs mt-1">
              Statut: {currentWeighing.statut} | 
              Poids brut: {currentWeighing.poids_brut} kg
              {currentWeighing.poids_tare && ` | Poids tare: ${currentWeighing.poids_tare} kg`}
              {currentWeighing.poids_net && ` | Poids net: ${currentWeighing.poids_net} kg`}
            </div>
          </div>
        </div>
        <div className="text-green-600 text-xs">
          {state.lastUpdated && 
            `Mis à jour: ${new Date(state.lastUpdated).toLocaleTimeString()}`
          }
        </div>
      </div>
    </div>
  );
};

export default CurrentWeighingInfo;
